var _g, _path, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_473_9455)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.0468,
    cy: 41.8732,
    r: 30.4572,
    fill: "#FB0000",
    fillOpacity: 0.63,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6413 35.7574C39.1392 35.5343 41.6529 35.5538 44.147 35.8156L44.7923 35.8833C46.0237 36.0125 47.0149 36.9454 47.221 38.1597L50.7016 36.3128C50.9375 36.1876 51.2205 36.1889 51.4552 36.3162C51.69 36.4435 51.8451 36.6799 51.8685 36.9456L51.8949 37.2466C52.191 40.6204 52.191 44.0136 51.8949 47.3874L51.8685 47.6883C51.8451 47.9541 51.69 48.1905 51.4552 48.3178C51.2205 48.4451 50.9375 48.4464 50.7016 48.3212L47.221 46.4743C47.0149 47.6885 46.0237 48.6215 44.7923 48.7507L44.147 48.8184C41.6529 49.0801 39.1392 49.0996 36.6413 48.8765L34.9619 48.7266C33.6965 48.6136 32.674 47.648 32.4902 46.3925C32.0946 43.6898 32.0946 40.9441 32.4902 38.2415C32.674 36.9859 33.6965 36.0204 34.9619 35.9074L36.6413 35.7574ZM47.4174 44.8265C47.5026 44.8399 47.5871 44.8674 47.6675 44.91L50.3801 46.3495C50.5726 43.6646 50.5726 40.9694 50.3801 38.2845L47.6675 39.7239C47.5871 39.7666 47.5026 39.7941 47.4174 39.8075C47.5662 41.4772 47.5662 43.1568 47.4174 44.8265Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50.7064,
    y: 25.748,
    width: 1.7916,
    height: 35.832,
    transform: "rotate(32.7976 50.7064 25.748)",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_473_9455",
    x: 0.839989,
    y: 0.666405,
    width: 82.4137,
    height: 82.4133,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.37481
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_473_9455"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_473_9455",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoOff);
export default __webpack_public_path__ + "static/media/VideoOff.bc1045438689b0df1af4b5e8e3c39ce4.svg";
export { ForwardRef as ReactComponent };